import { createSlice } from '@reduxjs/toolkit'
import PlayerInterface from '../../interfaces/Player.interface'

const initialState: PlayerInterface = {

}

export const playerPageSlice = createSlice({
    name: 'playerPage',
    initialState,
    reducers: {
        setPlayer: (_, { payload }) => payload,
        resetPlayer: () => initialState
    }
})
export const { setPlayer, resetPlayer } = playerPageSlice.actions
export default playerPageSlice.reducer